import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
// services
import { MessageService } from "../../../../services/message.service";
import { MasterService } from "../../../../services/master.service";
import * as languageLibrary from '../../../../services/language'
import { StoreService } from "src/app/services/store.service";
import { InsurancePolicy } from "src/app/models/insurance-policy.model";
import { Sale } from "src/app/models/sale.model";


@Component({
    selector: "auto-insurance",
    templateUrl: "./auto-insurance.component.html",
    styleUrls: ["./auto-insurance.component.scss"],
    standalone: false
})
export class AutoInsuranceComponent implements OnInit {

protected status: string | null = null;
    
    protected showTabs: boolean = false
    
    protected policyToCopy: InsurancePolicy;
    
    protected cpiPolicyInfo: InsurancePolicy;
    
    protected outsideInsurancePolicyInfo: InsurancePolicy;
    
    protected saleId: number;
    
    protected sale: Sale;
    
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    protected words = languageLibrary.language
    
    protected inactivePolicies: InsurancePolicy[] = [];
    
    protected idForAction: Number = 0;

    protected loading: boolean = false
    
    public listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break;
            default:
                break;
        }
    }
    
    public listenerChildrens = (e): void => {
        switch (e['message']) {
            case 'getAutoInsurance':
                this.getAutoInsuranceDetails()
                break;
            default:
                break;
        }
    }

    constructor(private route: ActivatedRoute, private ms: MessageService, private master: MasterService, private store: StoreService, private location: Location) {}

    ngOnInit() {
        this.saleId = parseInt(this.route.snapshot.params['saleId'])
        if (isNaN(this.saleId) || (this.saleId <= 0)) {
            this.saleId = 0
            return
        }

        this.getAutoInsuranceDetails()
    }

    private reset() {
        this.showTabs = true
        this.sale = null
        this.cpiPolicyInfo = null
        this.outsideInsurancePolicyInfo = null
        this.inactivePolicies = null
        this.idForAction
    }

    public clone(insuranceDetail) {
        this.policyToCopy = JSON.parse(JSON.stringify(insuranceDetail))
    }

    public setId(id) {
        this.idForAction = id
    }

    public duplicatePolicy() {
        this.cpiPolicyInfo = null
        this.outsideInsurancePolicyInfo = null
        
        const btn = document.getElementById("btn-close-modal-duplicate") as HTMLButtonElement
        if (btn) {
            btn.click()
        }
        
        this.policyToCopy.id = null
        this.policyToCopy.status = 'Duplicate - Not Saved'
        if (!this.policyToCopy.cpi) {
            this.outsideInsurancePolicyInfo = this.policyToCopy
            this.setActiveTab('personal-detail')
            return
        }

        this.cpiPolicyInfo = this.policyToCopy
        this.setActiveTab('cpi-detail')
    }

    public getAutoInsuranceDetails() {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        this.reset()
        this.loading = true

        this.master.get(`sales/${this.saleId}/insurance`, res => {
            this.loading = false
            
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.setSaleInformation(res.data.saleInfo)
            let activeTab = this.sale.financed ? 'cpi-detail' : 'personal-detail'
            
            if (res.data.activePolicies && (res.data.activePolicies.length > 0)) {
                this.showTabs = false
                if (res.data.activePolicies[0] && res.data.activePolicies[0].cpi) {
                    this.cpiPolicyInfo = res.data.activePolicies[0]
                    this.cpiPolicyInfo.expectedPayments = res.data.expectedPayments
                } 
                else {
                    this.outsideInsurancePolicyInfo = res.data.activePolicies[0]
                    activeTab = 'personal-detail'
                }
            }

            this.setActiveTab(activeTab)
            this.inactivePolicies = res.data.inactivePolicies
        })
    }

    /**
     * Select the active tab based on the value given.
     * @param activeTab The name of the active tab to select.
     */
    protected setActiveTab = (activeTab: string) => {
        const links: NodeListOf<HTMLAnchorElement> = document.querySelectorAll<HTMLAnchorElement>('.nav-tabs > .nav-item > a.nav-link')
        links.forEach((link) => {
            link.classList.remove('active')
        })

        const tabs: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('.tab-content > div.tab-pane')
        tabs.forEach((tab) => {
            tab.classList.remove('active')
            tab.classList.remove('show')
        })

        const tabLink: HTMLAnchorElement = document.getElementById(`${activeTab}-link`) as HTMLAnchorElement
        if (tabLink) {
            tabLink.classList.add('active')
        }

        const tab: HTMLElement = document.getElementById(`${activeTab}`) as HTMLElement
        if (tab) {
            tab.classList.add('active')
            tab.classList.add('show')
        }
    }

    public setSaleInformation(saleInfo) {
        if (!saleInfo || !saleInfo.id) {
            return
        }

        const salesTerm = saleInfo.saleTerms.find(saleTerm => saleTerm.active == true)
        
        let buyer = null
        if (saleInfo.saleBuyers && (saleInfo.saleBuyers.length > 0)) {
            buyer = saleInfo.saleBuyers[0]
        }

        if (!buyer) {
            return
        }

        this.sale = {
            ...(new Sale()),
            id: saleInfo.id,
            contactId: buyer.contact.id,
            saleDate: saleInfo.saleDate,
            buyer: buyer ? buyer.contact.lastName + ", " + buyer.contact.firstName : null,
            status: saleInfo.saleStatus.name,
            stock: saleInfo.saleVehicles[0] ? saleInfo.saleVehicles[0].inventory.stockNumber : null,
            vehicle: saleInfo.saleVehicles[0] ? saleInfo.saleVehicles[0].inventory.vehicle.modelYear + " " + saleInfo.saleVehicles[0].inventory.vehicle.make + " " + saleInfo.saleVehicles[0].inventory.vehicle.model : null,
            payoff: salesTerm ? salesTerm.loanPayoff : null,
            payment: salesTerm ? salesTerm.schedulePmtAmt : null,
            paymentCycle: (salesTerm && salesTerm.paymentCycle) ? salesTerm.paymentCycle.name : null,
            first: salesTerm ? salesTerm.firstScheduledPmtDue : null,
            bhph: saleInfo.bhph,
            financed: saleInfo.financed
        }
    }
}
